import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EpisodeCard = ({ episode, onPlay, onDownload, onShare, onBookmark }) => {
  const formatDuration = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    if (hours > 0) {
      return `${hours}ч ${minutes}м`;
    }
    return `${minutes}м`;
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date?.toLocaleDateString('ru-RU', { 
      day: '2-digit', 
      month: 'long', 
      year: 'numeric' 
    });
  };

  return (
    <div className="episode-card bg-card rounded-lg border border-border overflow-hidden hover:shadow-soft transition-all duration-200">
      <div className="flex flex-col sm:flex-row gap-4 p-4">
        <div className="episode-artwork flex-shrink-0 relative group">
          <div className="w-full sm:w-32 aspect-square rounded-lg overflow-hidden bg-muted">
            <Image 
              src={episode?.artwork} 
              alt={episode?.artworkAlt}
              className="w-full h-full object-cover"
            />
          </div>
          <button
            onClick={() => onPlay(episode)}
            className="absolute inset-0 flex items-center justify-center bg-background/80 opacity-0 group-hover:opacity-100 transition-opacity duration-200 rounded-lg"
            aria-label={`Воспроизвести ${episode?.title}`}
          >
            <div className="w-12 h-12 rounded-full bg-primary flex items-center justify-center">
              <Icon name="Play" size={24} color="var(--color-primary-foreground)" />
            </div>
          </button>
        </div>

        <div className="episode-info flex-1 min-w-0">
          <div className="flex items-start justify-between gap-3 mb-2">
            <h3 className="text-lg font-heading font-semibold text-foreground line-clamp-2 flex-1">
              {episode?.title}
            </h3>
            <button
              onClick={() => onBookmark(episode)}
              className="flex-shrink-0 p-2 rounded-full hover:bg-muted transition-colors duration-200"
              aria-label="Добавить в закладки"
            >
              <Icon 
                name={episode?.isBookmarked ? "Bookmark" : "BookmarkPlus"} 
                size={20} 
                color={episode?.isBookmarked ? 'var(--color-primary)' : 'var(--color-muted-foreground)'}
              />
            </button>
          </div>

          <p className="text-sm text-muted-foreground mb-3 line-clamp-2">
            {episode?.description}
          </p>

          <div className="flex flex-wrap items-center gap-4 mb-3">
            <div className="flex items-center gap-2 text-xs text-muted-foreground">
              <Icon name="Calendar" size={14} color="var(--color-muted-foreground)" />
              <span className="font-mono">{formatDate(episode?.publishDate)}</span>
            </div>
            <div className="flex items-center gap-2 text-xs text-muted-foreground">
              <Icon name="Clock" size={14} color="var(--color-muted-foreground)" />
              <span className="font-mono">{formatDuration(episode?.duration)}</span>
            </div>
            <div className="flex items-center gap-2 text-xs text-muted-foreground">
              <Icon name="Headphones" size={14} color="var(--color-muted-foreground)" />
              <span className="font-mono">{episode?.playCount?.toLocaleString('ru-RU')} прослушиваний</span>
            </div>
            <div className="flex items-center gap-2 text-xs text-muted-foreground">
              <Icon name="MessageCircle" size={14} color="var(--color-muted-foreground)" />
              <span className="font-mono">{episode?.commentCount} комментариев</span>
            </div>
          </div>

          <div className="flex flex-wrap gap-2">
            <Button
              variant="default"
              size="sm"
              iconName="Play"
              iconPosition="left"
              onClick={() => onPlay(episode)}
            >
              Слушать
            </Button>
            <Button
              variant="outline"
              size="sm"
              iconName="Download"
              iconPosition="left"
              onClick={() => onDownload(episode)}
            >
              Скачать
            </Button>
            <Button
              variant="ghost"
              size="sm"
              iconName="Share2"
              iconPosition="left"
              onClick={() => onShare(episode)}
            >
              Поделиться
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EpisodeCard;